import { useEffect, useRef, useState } from 'react'
import { renderSlidePreviewDocument, type RenderContext, type SlideContent } from 'lorena-templates'

const DECK_WIDTH = 640 // ver DOCS/00-visao-geral.md — todo clamp()/vw é calibrado pra este valor

interface Props {
  templateId: string
  content: SlideContent
  ctx?: RenderContext
  /** Largura de exibição desejada — o iframe interno continua a 640px reais e escala visualmente. */
  displayWidth?: number
}

/**
 * Preview ao vivo de um slide, isolado num iframe (nunca dangerouslySetInnerHTML
 * no DOM principal — o CSS do template tem um reset `*{margin:0;padding:0}`
 * global que quebraria a UI do app). Ver plano de implementação, seção
 * "Templates como função pura".
 */
export function SlidePreviewFrame({ templateId, content, ctx, displayWidth = 320 }: Props) {
  const [doc, setDoc] = useState('')
  const timer = useRef<ReturnType<typeof setTimeout>>()

  useEffect(() => {
    clearTimeout(timer.current)
    timer.current = setTimeout(() => {
      setDoc(renderSlidePreviewDocument({ templateId, content, ctx }))
    }, 150)
    return () => clearTimeout(timer.current)
  }, [templateId, content, ctx])

  const scale = displayWidth / DECK_WIDTH
  // 1080/1350 = aspect-ratio do .slide (ver DOCS/00-visao-geral.md)
  const displayHeight = (displayWidth * 1350) / 1080

  return (
    <div style={{ width: displayWidth, height: displayHeight, overflow: 'hidden', position: 'relative' }}>
      <iframe
        title={`preview-${templateId}`}
        srcDoc={doc}
        style={{
          width: DECK_WIDTH,
          height: (DECK_WIDTH * 1350) / 1080,
          border: 'none',
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
          pointerEvents: 'none',
        }}
      />
    </div>
  )
}
